import { HOME_H1, HOME_LEAD, HOME_LINKS } from "@/lib/seoAnswer";
import { fontStack } from "@/theme";
import { Box, Button, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";

export default function HomeIntro() {
  return (
    <Box component="header" sx={{ maxWidth: 820, mb: { xs: 2, md: 2.5 } }}>
      <Typography
        component="h1"
        sx={{
          fontFamily: fontStack.serif,
          fontSize: { xs: "2rem", md: "2.75rem" },
          letterSpacing: 0,
          lineHeight: 1.1,
          color: "ink.main",
          mb: 1,
        }}
      >
        {HOME_H1}
      </Typography>
      <Typography
        sx={{
          color: "text.secondary",
          fontSize: { xs: "0.98rem", md: "1.05rem" },
          lineHeight: 1.7,
          mb: 1.5,
        }}
      >
        {HOME_LEAD}
      </Typography>
      <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
        {HOME_LINKS.map((link) => (
          <Button
            key={link.href}
            component={RouterLink}
            to={link.href}
            size="small"
            variant="outlined"
            sx={{
              color: "ink.main",
              borderColor: "rule.strong",
              fontSize: "0.8125rem",
              "&:hover": {
                borderColor: "ink.main",
                backgroundColor: "transparent",
              },
            }}
          >
            {link.label}
          </Button>
        ))}
      </Box>
    </Box>
  );
}
